module.exports = __webpack_public_path__ + "img/linli.e0d53a8f.jpeg";